import React from 'react';
import { Typography, Box, Grid } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { Button } from '../reusable-components';
import { operatorAdviceReload } from '../App';
import useErrorReport from '../backend/useErrorReport';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error caught by ErrorBoundary:", error, errorInfo);

        // You can call error report passed via props
        if (this.props.errorReport) {
            this.props.errorReport(error.message, errorInfo.componentStack);
        }
    }

    render() {
        const { t } = this.props;

        if (this.state.hasError) {
            return (
                <Grid
                    container
                    justifyContent="flex-start"
                    direction="column"
                    minHeight="800px"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                        background: 'var(--background_1)',
                        paddingTop: '100px',
                    }}
                >
                    <Box>
                        <Typography sx={{ fontFamily: 'var(--font-title)', fontSize: '18px' }} gutterBottom>
                            {t('error_title')}
                        </Typography>
                        <Typography sx={{ fontFamily: 'var(--font-body)', fontSize: '14px' }} paragraph>
                            {t('error_text')}
                        </Typography>
                        <Button onClick={() => operatorAdviceReload()}>
                            {t('reload')}
                        </Button>
                    </Box>
                </Grid>
            );
        }

        return this.props.children;
    }
}

// Wrap in a functional component to use the hook
const ErrorBoundaryWithHook = (props) => {
    const errorReport = useErrorReport();
    return <ErrorBoundary {...props} errorReport={errorReport.reportError} />;
};

export default withTranslation()(ErrorBoundaryWithHook);
